/**
 * Reaction Picker Component
 * Floating reaction emoji picker
 */
import React from 'react';

const ReactionPicker = ({
  isOpen,
  onClose,
  reactions,
  onSendReaction
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-[9990] flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
      data-testid="reaction-picker-overlay"
    >
      <div 
        className="bg-gray-900 rounded-2xl p-4 border border-white/20" 
        onClick={e => e.stopPropagation()}
        data-testid="reaction-picker"
      >
        <p className="text-white text-sm mb-3 text-center">Send a reaction</p>
        <div className="grid grid-cols-4 gap-2">
          {reactions.map(reaction => (
            <button
              key={reaction.id}
              onClick={() => onSendReaction(reaction)}
              className="w-12 h-12 rounded-lg bg-black/30 hover:bg-white/10 flex items-center justify-center text-2xl transition-transform hover:scale-110"
              data-testid={`reaction-${reaction.id}`}
            >
              {reaction.emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactionPicker;
